export function convertPixelsToPoints(pixels) {
  return pixels * 0.75
}
